import type { SettingsPageId } from "./settings-page-definitions";

export const REQUIRED_ARGS: Readonly<
  Partial<Record<SettingsPageId, ReadonlyArray<string>>>
> = {
  "preferences-shortcut-edit": ["shortcutId"],
  "preferences-voice-vocabulary-word": ["wordId"],
  "connections-tool": ["tool"],
  "connections-app": ["app"],
  "plugins-plugin": ["slug", "version"],
  "projects-project": ["projectId"],
  "projects-folder": ["projectId", "folderId"],
  "projects-git": ["projectId", "folderId"],
  "projects-dev-server": ["projectId", "folderId"],
  "projects-add-folder": ["projectId"],
  "skills-skill": ["skillId"],
  "skills-customize": ["skillId"],
  "memory-proposal": ["reviewId"],
};

/**
 * Optional arguments a page keeps when it is rebuilt as an ancestor of a deep
 * link. `skills-skill` keeps `kind` because a work procedure and an execution
 * skill can share an ID, and `kind` selects which store's detail opens. Only
 * applies to pages listed in REQUIRED_ARGS.
 */
export const CARRIED_ARGS: Readonly<
  Partial<Record<SettingsPageId, ReadonlyArray<string>>>
> = {
  "skills-skill": ["kind"],
};

export const TAB_TARGETS: ReadonlyMap<string, SettingsPageId> = new Map<
  string,
  SettingsPageId
>([
  ["help-shortcuts", "preferences-shortcuts"],
  ["profile", "account"],
  ["billing", "account"],
  ["usage", "connections-usage"],
  ["connected-accounts", "connections"],
  ["companion", "preferences-ai-tools"],
  ["projects", "projects"],
  ["skills", "skills"],
  ["memory", "memory"],
  ["help", "help"],
  ["appearance", "preferences-appearance"],
  ["notifications", "preferences-sounds"],
  ["voice", "preferences-voice"],
  ["contact", "help-community"],
]);
